(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["soil-calculator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var NAMES = { bags: 'tonne bags', m3: 'cubic metres', litres: 'litres' };
    var SHORT = { bags: 'tonne bags', m3: 'm³', litres: 'litres' };
    var DECIMALS = { bags: 2, m3: 3, litres: 0 };
    var ORDER = ['bags', 'm3', 'litres'];

    function format(n, dp) {
      return n.toLocaleString('en-GB', { minimumFractionDigits: dp, maximumFractionDigits: dp });
    }

    function init(root) {
      if (root.getAttribute('data-rsc-ready')) return;
      root.setAttribute('data-rsc-ready', 'true');

      var bed = root.querySelector('[data-rsc-bed]');
      var qty = root.querySelector('[data-rsc-qty]');
      var minus = root.querySelector('[data-rsc-minus]');
      var plus = root.querySelector('[data-rsc-plus]');
      var unitInputs = root.querySelectorAll('[data-rsc-unit-input]');
      var modeInputs = root.querySelectorAll('[data-rsc-mode-input]');
      var num = root.querySelector('[data-rsc-num]');
      var unitEl = root.querySelector('[data-rsc-unit]');
      var what = root.querySelector('[data-rsc-what]');
      var partsList = root.querySelector('[data-rsc-parts]');
      var round = root.querySelector('[data-rsc-round]');
      var size = root.querySelector('[data-rsc-size]');
      var perRow = root.querySelector('[data-rsc-per-row]');
      var per = root.querySelector('[data-rsc-per]');
      var link = root.querySelector('[data-rsc-link]');
      var sr = root.querySelector('[data-rsc-sr]');
      var readyLitres = parseFloat(root.getAttribute('data-ready-litres')) || 750;

      var parts = [].map.call(root.querySelectorAll('[data-rsc-part]'), function (row) {
        return {
          pct: parseFloat(row.getAttribute('data-pct')) || 0,
          bag: parseFloat(row.getAttribute('data-bag')) || 0,
          out: row.querySelector('[data-rsc-part-value]'),
          spare: row.querySelector('[data-rsc-part-spare]'),
          litres: 0,
          bags: 0
        };
      });
      var pctSum = parts.reduce(function (t, p) { return t + p.pct; }, 0);

      function readQty() {
        var n = parseInt(qty.value, 10);
        if (isNaN(n) || n < 1) return 1;
        return Math.min(n, 99);
      }

      function readChecked(inputs, fallback) {
        for (var i = 0; i < inputs.length; i++) {
          if (inputs[i].checked) return inputs[i].value;
        }
        return fallback;
      }

      function singular(unit, value) {
        return unit === 'bags' && format(value, 2) === '1.00';
      }

      function label(unit, value) {
        return singular(unit, value) ? 'tonne bag' : NAMES[unit];
      }

      function short(unit, value) {
        return singular(unit, value) ? 'tonne bag' : SHORT[unit];
      }

      function update() {
        var opt = bed.options[bed.selectedIndex];
        if (!opt) return;

        var w = parseFloat(opt.getAttribute('data-w'));
        var l = parseFloat(opt.getAttribute('data-l'));
        var h = parseFloat(opt.getAttribute('data-h'));
        var count = readQty();
        var unit = readChecked(unitInputs, 'bags');
        var own = readChecked(modeInputs, 'ready') === 'own' && parts.length > 0 && pctSum > 0;

        /* mm x mm x mm gives mm3; one litre is 1,000,000 mm3 */
        var litres = ((w * l * h) / 1000000) * count;

        var bagsTotal;
        if (own) {
          bagsTotal = 0;
          parts.forEach(function (p) {
            p.litres = litres * p.pct / pctSum;
            p.bags = p.bag > 0 ? p.litres / p.bag : 0;
            bagsTotal += p.bags;
          });
        } else {
          bagsTotal = litres / readyLitres;
        }

        function valueFor(u) {
          if (u === 'bags') return bagsTotal;
          if (u === 'm3') return litres / 1000;
          return litres;
        }

        var main = valueFor(unit);
        num.textContent = format(main, DECIMALS[unit]);
        unitEl.textContent = label(unit, main);

        what.textContent = own ? 'to fill your bed, made up of' : 'of ready-made raised bed mix';

        /* buying whole tonne bags leaves some soil over: bags bought x litres in a bag, less what is needed */
        var spareTotal = 0;
        if (partsList) {
          partsList.hidden = !own;
          parts.forEach(function (p) {
            var v = unit === 'bags' ? p.bags : (unit === 'm3' ? p.litres / 1000 : p.litres);
            p.out.textContent = format(v, DECIMALS[unit]) + ' ' + short(unit, v);
            if (own && unit === 'bags' && p.bag > 0) {
              var bought = Math.max(1, Math.ceil(p.bags - 0.000001));
              var spare = bought * p.bag - p.litres;
              spareTotal += spare;
              p.spare.textContent = 'Buy ' + bought + (bought === 1 ? ' bag' : ' bags') + ', ' + format(spare, 0) + ' litres spare';
              p.spare.hidden = false;
            } else {
              p.spare.hidden = true;
            }
          });
        }

        if (unit === 'bags') {
          var whole;
          if (own) {
            whole = parts.reduce(function (t, p) {
              return t + (p.bags > 0 ? Math.max(1, Math.ceil(p.bags - 0.000001)) : 0);
            }, 0);
          } else {
            whole = Math.max(1, Math.ceil(bagsTotal - 0.000001));
            spareTotal = whole * readyLitres - litres;
          }
          var spareText = Math.round(spareTotal) >= 1 ? ' That leaves about ' + format(spareTotal, 0) + ' litres of spare soil.' : '';
          round.textContent = 'Rounded up, that is ' + whole + (whole === 1 ? ' tonne bag' : ' tonne bags') +
            (own ? ' in all, bought material by material.' : '.') + spareText;
          round.hidden = false;
        } else {
          round.hidden = true;
        }

        size.textContent = w + 'mm W × ' + l + 'mm L × ' + h + 'mm H';

        if (count > 1) {
          var each = main / count;
          per.textContent = format(each, DECIMALS[unit]) + ' ' + label(unit, each);
          perRow.hidden = false;
        } else {
          perRow.hidden = true;
        }

        var others = ORDER.filter(function (u) { return u !== unit; });
        others.forEach(function (u, i) {
          root.querySelector('[data-rsc-alt-label="' + i + '"]').textContent = NAMES[u];
          root.querySelector('[data-rsc-alt-value="' + i + '"]').textContent = format(valueFor(u), DECIMALS[u]);
        });

        var url = opt.getAttribute('data-url');
        if (url) {
          link.textContent = 'View ' + opt.textContent.trim().replace(' - ', ' ');
          link.setAttribute('href', url);
          link.hidden = false;
        } else {
          link.hidden = true;
        }

        sr.textContent = 'You will need ' + num.textContent + ' ' + unitEl.textContent +
          (own ? ' of soil, made from your own mix' : ' of ready-made raised bed mix') +
          ' for ' + count + (count === 1 ? ' raised bed' : ' raised beds') + ', ' + opt.textContent + '.';
      }

      function setQty(n) {
        qty.value = Math.max(1, Math.min(99, n));
        update();
      }

      bed.addEventListener('change', update);
      qty.addEventListener('input', update);
      qty.addEventListener('change', function () { qty.value = readQty(); update(); });
      minus.addEventListener('click', function () { setQty(readQty() - 1); });
      plus.addEventListener('click', function () { setQty(readQty() + 1); });
      for (var i = 0; i < unitInputs.length; i++) unitInputs[i].addEventListener('change', update);
      for (var j = 0; j < modeInputs.length; j++) modeInputs[j].addEventListener('change', update);

      update();
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-rsc]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }

    initAll();
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ua_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.desktopSearchContainer = document.querySelector('.search-modal');
      this.desktopSearchButton = document.querySelector('.header__icon--search');

      this.desktopSearchButton.addEventListener('click', () => {
  this.desktopSearchContainer.toggleAttribute('open');
  if (this.desktopSearchContainer.hasAttribute('open')) {
    document.addEventListener('click', this.handleOutsideClick);
    // ADD THIS: focus the input after a short delay to allow the modal to render
    setTimeout(() => {
      const searchInput = this.desktopSearchContainer.querySelector('.search__input');
      if (searchInput) searchInput.focus();
    }, 50);
  } else {
    document.removeEventListener('click', this.handleOutsideClick);
  }
});

      this.handleOutsideClick = (event) => { 
        if (!this.desktopSearchContainer.contains(event.target) && !this.desktopSearchButton.contains(event.target) || event.target.classList.contains('modal-overlay')) {
          this.desktopSearchContainer.removeAttribute('open');
          this.closeSearchModal();
          document.removeEventListener('click', this.handleOutsideClick);
        }
      };

      this.setHeaderHeight();

      window.addEventListener('resize', this.setHeaderHeight.bind(this));
      window.matchMedia('(max-width: 989px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.documentElement.classList.add('header--hidden');
      this.header.querySelector('.search-modal').removeAttribute('open');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.documentElement.classList.remove('header--hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.documentElement.classList.remove('header--hidden');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
